import ReactModal from 'react-modal';

// Register with react-modal
try {
  ReactModal.setAppElement('#page');
} catch (e) {
  // Do nothing, page is missing
}
